export default function Example() {
    return (
        <main className="w-full h-full grid min-h-full place-items-center bg-white dark:bg-gray-900 px-6 py-24 sm:py-32 lg:px-8">
            <div className="text-center p-8 sm:p-12 bg-white dark:bg-slate-800 z-10">
                <p className="text-base font-semibold text-primary-600">404</p>
                <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 dark:text-white sm:text-5xl">페이지 정보가 없습니다.</h1>
                <p className="mt-6 text-base leading-7 text-gray-400">요청하신 페이지 정보를 찾을 수 없습니다.</p>
                <div className="mt-10 flex items-center justify-center gap-x-6">
                    <a
                        href="/"
                        className="rounded-md bg-primary-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-primary-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    >
                        홈으로
                    </a>
                </div>
            </div>
        </main>
    )
}
